import React, { useState, useEffect } from "react";
import SharedHelmet from "../Helmet";
import { FirstAds, SecondAds } from "../../Ads";
import imageUrl from "../../../images/mother.webp";
import BlinkingText from "../../BlinkingText";
import RelatedLinks from "../RelatedLinks";
import MainCalculatorsList from "./MainCalculators";
const TITLE = "Berapa Hari Lagi Hari Ibu 2026 - Hitung Mundur Hari Ibu 2026";
const DESCRIPTION =
  "Berapa hari lagi Hari Ibu, Hari Ibu 2026, kapan Hari Ibu, berapa hari lagi Hari Ibu, kapan Hari Ibu 2026, tanggal Hari Ibu 2026, jadwal Hari Ibu 2026, berapa hari lagi Hari Ibu 2026, Hari Ibu 2025, berapa hari lagi Hari Ibu, berapa hari lagi perayaan Hari Ibu, Hari Ibu 2026, berapa hari lagi Hari Ibu 2026, jadwal Hari Ibu 2025, tanggal Hari Ibu, berapa hari lagi Hari Ibu 2026, kapan Hari Ibu, berapa hari lebaran ibu, Hari Ibu, tanggal Hari Ibu, hari ibu, berapa hari lagi Hari Ibu, Hari Ibu 2026, 1444 Hijriah, berapa hari lagi Hari Ibu 2026, sisa hari Hari Ibu, berapa lama lagi Hari Ibu 2026, jadwal Hari Ibu 2026, selamat Hari Ibu, tanggal Hari Ibu 2026, berapa hari lagi Hari Ibu, Hari Ibu 2026";
const KEYWORDS =
  "berapa hari lagi Hari Ibu, Hari Ibu 2026, kapan Hari Ibu, berapa hari lagi Hari Ibu, kapan Hari Ibu 2026, tanggal Hari Ibu 2026, jadwal Hari Ibu 2026, berapa hari lagi Hari Ibu 2026, Hari Ibu 2025, hitung mundur Hari Ibu, selamat Hari Ibu 2026";
const OG_URL = "https://do-calculate.com/articles-id/motherday";
function MothersDay() {
  const calculateTimeLeft = (targetDate) => {
    const now = new Date();
    const difference = targetDate - now;
    let timeLeft = {};
    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }
    return timeLeft;
  };
  const initialDate = new Date("2026-03-21T00:00:00");
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(initialDate));
  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft(initialDate));
    }, 1000);
    return () => clearTimeout(timer);
  }, [timeLeft]);
  const mothersDayDates = [
    { name: "Hari Ibu 2026", date: new Date("2026-03-21T00:00:00") },
    { name: "Hari Ibu 2027", date: new Date("2027-03-21T00:00:00") },
    { name: "Hari Ibu 2028", date: new Date("2028-03-21T00:00:00") },
    { name: "Hari Ibu 2029", date: new Date("2029-03-21T00:00:00") },
    { name: "Hari Ibu 2030", date: new Date("2030-03-21T00:00:00") },
  ];
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <FirstAds />
      </div>
      <h1 className="p-3 mb-2 bg-success text-white">
        Berapa Hari Lagi Hari Ibu 2026
      </h1>
      <div>
        <BlinkingText text="Berapa hari lagi Hari Ibu: Diperkirakan Hari Ibu 2026 jatuh pada hari Sabtu tanggal 21-03-2026 Masehi." />
      </div>
      <div className="row">
        <div id="timer" style={{ width: "100%", fontSize: "40px" }}>
          <table
            style={{
              width: "100%",
              textAlign: "center",
              borderCollapse: "collapse",
              border: "1px solid #ccc",
            }}
          >
            <thead>
              <tr>
                <th>Hari</th>
                <th>Jam</th>
                <th>Menit</th>
                <th>Detik</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td id="days">{timeLeft.days}</td>
                <td id="hours">{timeLeft.hours}</td>
                <td id="minutes">{timeLeft.minutes}</td>
                <td id="seconds">{timeLeft.seconds}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="row">
        <SecondAds />
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <div>
            <h2
              className="p-3 mb-2 bg-success text-white"
              style={{ color: "#333", fontSize: "36px", textAlign: "center" }}
            >
              Jadwal Hari Ibu Mendatang
            </h2>
            <table
              style={{
                fontSize: "24px",
                width: "100%",
                textAlign: "center",
                borderCollapse: "collapse",
                border: "2px solid #ccc",
                borderRadius: "8px",
                overflow: "hidden",
              }}
            >
              <thead>
                <tr style={{ backgroundColor: "#f2f2f2" }}>
                  <th style={{ padding: "16px", borderBottom: "2px solid #ccc" }}>
                    Jadwal Hari Ibu
                  </th>
                  <th style={{ padding: "16px", borderBottom: "2px solid #ccc" }}>
                    Tanggal
                  </th>
                  <th style={{ padding: "16px", borderBottom: "2px solid #ccc" }}>
                    Sisa Hari
                  </th>
                </tr>
              </thead>
              <tbody>
                {mothersDayDates.map((date, index) => (
                  <tr
                    key={index}
                    style={{
                      backgroundColor: index % 2 === 0 ? "#fff" : "#f9f9f9",
                    }}
                  >
                    <td style={{ padding: "12px" }}>{date.name}</td>
                    <td style={{ padding: "12px" }}>
                      {date.date.toLocaleDateString("en-GB")}
                    </td>
                    <td style={{ padding: "12px" }}>
                      {calculateTimeLeft(date.date).days} hari
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="col" style={{ paddingTop: "28px" }}>
          <MainCalculatorsList></MainCalculatorsList>
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <h3 className="p-3 mb-2 bg-success text-white">
            Berapa Hari Lagi Hari Ibu 2026
          </h3>
          <p>
            Dalam artikel ini, kami menyajikan hitung mundur lengkap menuju Hari Ibu,
            agar Anda selalu mengetahui berapa hari lagi hari yang istimewa ini tiba.
            Banyak di antara kita yang bertanya berapa hari lagi Hari Ibu, oleh karena
            itu kami hadirkan hitung mundur Hari Ibu agar Anda dapat mengetahui
            berapa hari lagi Hari Ibu, berapa hari lagi Hari Ibu 2026, berapa hari
            tersisa hingga Hari Ibu. Lihat hitung mundur Hari Ibu di atas.
          </p>
          <p>
            Berdasarkan situs{" "}
            <a href="/calculator/id/gregorian_to_hijri/">konversi tanggal</a>, Hari
            Ibu 2026 bertepatan dengan hari Sabtu 21-03-2026 Masehi. Anda dapat
            melihat hitung mundur Hari Ibu 2026 di artikel ini.
          </p>
          <p>
            Temukan di sini hitung mundur Hari Ibu, di mana Anda dapat mengetahui
            berapa hari lagi Hari Ibu.
          </p>
          <hr />
          <RelatedLinks />
          <hr />
          <h3 className="p-3 mb-2 bg-success text-white">
            Hitung Berapa Hari Lagi Hari Ibu
          </h3>
          <p>
            Melalui program hitung mundur Hari Ibu, Anda dapat mengetahui berapa hari
            lagi Hari Ibu dalam kalender Masehi maupun Hijriah, serta mengetahui
            berapa sisa hari menuju Hari Ibu, berapa hari lagi Hari Ibu dalam hitungan
            hari, kapan Hari Ibu tiba, dan jadwal Hari Ibu tahun ini. Selamat Hari Ibu,
            semoga Allah senantiasa memberikan kebaikan kepada kita semua.
          </p>
          <h3 className="p-3 mb-2 bg-success text-white">Hari Ibu</h3>
          <p>
            Hari Ibu adalah perayaan tahunan untuk menghormati dan memuliakan para
            ibu. Ini adalah hari di mana setiap orang mengungkapkan rasa syukur dan
            penghargaan kepada ibu mereka melalui hadiah, ucapan yang tulus, dan
            tindakan yang bermakna. Hari Ibu dirayakan di berbagai belahan dunia
            pada tanggal yang berbeda-beda, namun tujuannya sama: menghormati para
            ibu atas segala yang mereka berikan untuk keluarga dan masyarakat.
          </p>
          <div>
            <br />
            <img
              src={imageUrl}
              alt="Berapa hari lagi Hari Ibu"
              width="800"
              height="450"
              style={{ width: '100%', height: 'auto', maxWidth: '800px' }}
              loading="lazy"
            />
            <br />
          </div>
          <h3 className="p-3 mb-2 bg-success text-white">
            Cara Merayakan Hari Ibu
          </h3>
          <p>
            – Ungkapkan rasa terima kasih dan penghargaan kepada ibu melalui
            kata-kata yang tulus dan hadiah yang bermakna.
            <br />
            – Habiskan waktu berkualitas bersama ibu dan rayakan bersamanya dengan
            berbagai cara seperti makan bersama atau jalan-jalan.
            <br />
            – Ingatkan para ibu betapa pentingnya mereka dan besarnya peran mereka
            dalam kehidupan keluarga dan masyarakat.
            <br />
          </p>
        </div>
        <br />
      </div>
    </div>
  );
}
export default MothersDay;
